<template>
  <div class="display-style-name-details">
    <div class="style-name">
      <MdTypography
        ref="styleNameRef"
        v-tooltip="isEllipsisActive ? { content: data.displayStyleName.name, placement: 'bottom' } : ''"
        data-qa-id="font-display-styles--styleName" 
        tag="div" 
        color="spirits--900"
        variant="body2--medium"
        @mouseover="checkEllipsis"
      >
        {{ data.displayStyleName.name }}
      </MdTypography>
    </div>
    <div class="style-version">
      <MdTypography 
        data-qa-id="font-display-styles--fileFormat" 
        tag="div" 
        color="spirits--900" 
        variant="body2--regular"
      >
        {{ fileFormat }}
      </MdTypography>
      <MdTypography 
        data-qa-id="font-display-styles--styleVersion" 
        tag="div" 
        color="spirits--700" 
        variant="body2--regular"
      >
        {{ versionValue }}
      </MdTypography>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { MdTypography } from '@antiqua-dls/vue-components'

export default {
  name: 'DisplayStyleNameCol',
  components: {
    MdTypography
  },
  props: {
    params: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const { data } = props.params
    const versionValue = computed(() => {
      return data.displayStyleName.version || '';
    });

    const fileFormat = computed(() => {
      return data.displayStyleName.fileFormat + ' ' + data.displayStyleName.formatFlavor || '';
    });
    
    const styleNameRef = ref(null)
    const isEllipsisActive = ref(false)

    const checkEllipsis = () => {
      const el = styleNameRef.value?.$el?.shadowRoot?.querySelector('[part="md-typography"]')
      if (el) {
        isEllipsisActive.value = el.scrollWidth > el.clientWidth
      }
    }

    return {
      styleNameRef,
      checkEllipsis,
      versionValue,
      isEllipsisActive,
      data,
      fileFormat,
    };
  }
}
</script>

<style lang="scss">
.display-style-name-details {
  display: flex;
  flex-direction: column;
  gap: var(--md-spacing-unit--2xs);
  align-items: flex-start;

  .style-name {
    flex: 1;
    min-width: 0;
    ::part(md-typography) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .style-version {
    min-width: 0;
    display: flex;
    gap: var(--md-spacing-unit--xs);

    ::part(md-typography) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 0.875rem;
    }
  }
}
</style>
